import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import API from '../../services/API';
import Form from './components/Form';
import Table from './components/Table';
import { handleFieldChange } from '../../Utils';

class BidderCpcCountry extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            report: [],
            selectedSource: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(filters) {
        this.setState({
            isLoading: true
        });

        API.BidderCpcCountry.get(filters).then(report => {
            this.setState({ report, isLoading: false });
        });
    }

    getTable() {
        const { report } = this.state;

        if(!report.length) return <p>No data</p>;

        return <Table report={report}/>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Cpc Country"/>
                <Form onSubmit={this.handleSubmit}/>
                {this.getTable()}
            </Container>
        );
    }
}

export default BidderCpcCountry;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpcCountry/index.js